/* Lichcards - designlaag, gedragsdeel (stijlaudit 2026-08-16)
   Puur cosmetisch: leest wat er al op de pagina staat en zet er iets netters neer.
   Uitzetten = {% render 'lichcards-design' %} uit layout/theme.liquid halen. */
(function () {
  'use strict';

  var BODY = document.body;
  if (!BODY) return;
  BODY.classList.add('lc-design');

  /* ====================================================================
     SCHAKELAARS — hier zet je onderdelen aan of uit.
     ==================================================================== */
  var AAN = {
    zoekbalk: false,   // eigen zoekrij onder de header (uitgezet 16-08 op verzoek)
    megamenu: false,   // eigen TCG-paneel; UIT, het thema heeft er zelf al een
    tegels:   true     // collectietegels boven het productraster
  };

  /* Menu-items die uit het hoofdmenu mogen omdat ze al in de utility-balk
     rechtsboven staan. Alleen verbergen — in de Shopify-navigatie blijft
     alles gewoon staan, dus het live thema verandert hier niet van. */
  var MENU_VERBERGEN = ['kaarten verkopen'];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var S = 'fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"';
  var ICONS = {
    pokemon:   '<circle cx="12" cy="12" r="9" ' + S + '/><path d="M3 12h6m6 0h6" ' + S + '/><circle cx="12" cy="12" r="2.6" ' + S + '/>',
    magic:     '<path d="M12 3c2.6 3.4 5 6.2 5 9a5 5 0 0 1-10 0c0-2.8 2.4-5.6 5-9Z" ' + S + '/>',
    onepiece:  '<path d="M6.5 15c0-4 2.4-7 5.5-7s5.5 3 5.5 7" ' + S + '/><path d="M3 15.5h18" ' + S + '/><path d="M8.5 12h7" ' + S + '/>',
    yugioh:    '<path d="M12 3.5 21 19H3l9-15.5Z" ' + S + '/><circle cx="12" cy="14" r="2.2" ' + S + '/>',
    lorcana:   '<path d="M12 3.5 20 8v8l-8 4.5L4 16V8l8-4.5Z" ' + S + '/><path d="M12 9.5v6" ' + S + '/>',
    dragonball:'<circle cx="12" cy="12" r="8.5" ' + S + '/><path d="m12 8 1.4 2.9 3.1.4-2.3 2.2.6 3.1-2.8-1.5-2.8 1.5.6-3.1-2.3-2.2 3.1-.4L12 8Z" ' + S + '/>',
    digimon:   '<rect x="5" y="5" width="14" height="14" rx="2.5" ' + S + '/><rect x="9" y="9" width="6" height="6" rx="1" ' + S + '/><path d="M9 3v2m6-2v2M9 19v2m6-2v2M3 9h2m-2 6h2m14-6h2m-2 6h2" ' + S + '/>',
    starwars:  '<path d="M12 2.5v19M2.5 12h19M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4" ' + S + '/>',
    riftbound: '<path d="M13.5 2.5 6 13h5l-2.5 8.5L18 10h-5l.5-7.5Z" ' + S + '/>',
    gundam:    '<path d="M4 8.5 12 4l8 4.5v5L12 20l-8-6.5v-5Z" ' + S + '/><path d="M8 11h8" ' + S + '/>',
    fab:       '<path d="M4.5 4.5 15 15m4.5 4.5L17 17M19.5 4.5 9 15m-4.5 4.5L7 17" ' + S + '/>',
    weiss:     '<rect x="3.5" y="4.5" width="8" height="15" rx="1.5" ' + S + '/><rect x="12.5" y="4.5" width="8" height="15" rx="1.5" ' + S + '/>',
    sports:    '<rect x="4" y="3.5" width="16" height="17" rx="2" ' + S + '/><path d="m12 8 1.3 2.7 2.9.4-2.1 2 .5 2.9-2.6-1.4-2.6 1.4.5-2.9-2.1-2 2.9-.4L12 8Z" ' + S + '/>',
    minecraft: '<rect x="4" y="4" width="16" height="16" rx="1.5" ' + S + '/><path d="M4 12h16M12 4v16" ' + S + '/>',
    adrenalyn: '<rect x="4" y="3.5" width="16" height="17" rx="2" ' + S + '/><path d="m13.5 7-4.5 6.5h3l-1 4L15.5 11h-3l1-4Z" ' + S + '/>',
    altered:   '<path d="M4 7.5 12 4l8 3.5-8 3.5-8-3.5Z" ' + S + '/><path d="M4 13.5 12 10l8 3.5-8 3.5-8-3.5Z" ' + S + '/><path d="M8 18.5l4 1.5 4-1.5" ' + S + '/>',
    hololive:  '<rect x="9" y="3" width="6" height="10" rx="3" ' + S + '/><path d="M5.5 11a6.5 6.5 0 0 0 13 0" ' + S + '/><path d="M12 17.5v3M8.5 20.5h7" ' + S + '/>',
    finalfantasy: '<path d="M12 2.5 18 9l-6 12.5L6 9l6-6.5Z" ' + S + '/><path d="M6 9h12" ' + S + '/>',
    singles:   '<rect x="3" y="6" width="11" height="14" rx="1.8" transform="rotate(-8 8.5 13)" ' + S + '/><rect x="10" y="4" width="11" height="14" rx="1.8" transform="rotate(8 15.5 11)" ' + S + '/>',
    sealed:    '<path d="M3.5 7.5 12 3.5l8.5 4v9L12 20.5l-8.5-4v-9Z" ' + S + '/><path d="M3.5 7.5 12 11.5l8.5-4M12 11.5v9" ' + S + '/>',
    board:     '<rect x="3.5" y="3.5" width="17" height="17" rx="3" ' + S + '/><circle cx="8.5" cy="8.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="15.5" cy="8.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none"/><circle cx="8.5" cy="15.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="15.5" cy="15.5" r="1.1" fill="currentColor" stroke="none"/>',
    acc:       '<path d="M5 4.5h14v15H5z" ' + S + '/><path d="M8.5 4.5v6l3.5-2 3.5 2v-6" ' + S + '/>',
    buy:       '<path d="M12 3.5v11m0 0 4-4m-4 4-4-4" ' + S + '/><path d="M4.5 16v3.5h15V16" ' + S + '/>',
    store:     '<path d="M4 10v9.5h16V10" ' + S + '/><path d="M3 10 5 4.5h14L21 10a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z" ' + S + '/>',
    star:      '<path d="m12 3.5 2.6 5.4 5.9.8-4.3 4.1 1.1 5.9L12 16.9l-5.3 2.8 1.1-5.9L3.5 9.7l5.9-.8L12 3.5Z" ' + S + '/>',
    phone:     '<path d="M6 3.5h4l1.5 4-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2 4 1.5v4a2 2 0 0 1-2 2C10.5 20 4 13.5 4 5.5a2 2 0 0 1 2-2Z" ' + S + '/>',
    truck:     '<path d="M2.5 6.5h11v9h-11z" ' + S + '/><path d="M13.5 9.5H17l3 3v3h-6.5" ' + S + '/><circle cx="6.5" cy="17.5" r="1.8" ' + S + '/><circle cx="16.5" cy="17.5" r="1.8" ' + S + '/>',
    zoek:      '<circle cx="11" cy="11" r="6.5" ' + S + '/><path d="m16 16 4.5 4.5" ' + S + '/>'
  };

  /* Officiële spellogo's (verzoek Lucas, 17-08-2026): in het menu tonen we waar
     mogelijk het logo van het spel in plaats van het lijn-icoon. Bestanden staan
     in Shopify -> Inhoud -> Bestanden. Spellen zonder logo houden hun icoon. */
  var CDN = 'https://cdn.shopify.com/s/files/1/0647/0411/9019/files/';
  var LOGOS = {
    pokemon:   CDN + 'Pokemon_Trading_Card_Game2.png',
    magic:     CDN + 'Lichcards_kopen_Magic_the_Gathering_TCG.png',
    onepiece:  CDN + 'logaster-2022-07-one-piece-symbol.png',
    yugioh:    CDN + 'Yu-Gi-Oh_Trading_card_game_lichcards_kopen.png',
    lorcana:   CDN + 'tcg-logo-lorcana.png',
    starwars:  CDN + 'tcg-logo-star-wars-unlimited.png',
    digimon:   CDN + 'tcg-logo-digimon-2025.jpg',
    fab:       CDN + 'tcg-logo-flesh-and-blood.png',
    weiss:     CDN + 'tcg-logo-weiss-schwarz.jpg',
    vanguard:  CDN + 'tcg-logo-vanguard.png',
    dragonball: CDN + 'tcg-logo-dragon-ball-super.png',
    riftbound: CDN + 'tcg-logo-riftbound.png',
    minecraft: CDN + 'tcg-logo-minecraft.png',
    hololive:  CDN + 'tcg-logo-hololive.png',
    lichguard: CDN + 'LichGuard_2.png'
  };

  /* Volgorde telt: de eerste regel die past, wint. Specifieke namen dus boven
     de brede regels (magic vangt "gathering", sealed vangt "tcg"). */
  var GAMES = [
    { k: 'minecraft',    icon: 'minecraft',    c: '#4f7a35', re: /minecraft/i },
    { k: 'adrenalyn',    icon: 'adrenalyn',    c: '#1b6fa8', re: /adrenalyn/i },
    { k: 'altered',      icon: 'altered',      c: '#2f7d6b', re: /altered/i },
    { k: 'hololive',     icon: 'hololive',     c: '#2f93c4', re: /hololive/i },
    { k: 'finalfantasy', icon: 'finalfantasy', c: '#3b5ba5', re: /final\s?fantasy/i },
    { k: 'pokemon',    icon: 'pokemon',    c: '#b58900', re: /pok[eé]mon/i },
    { k: 'magic',      icon: 'magic',      c: '#a8631b', re: /magic|mtg|gathering/i },
    { k: 'onepiece',   icon: 'onepiece',   c: '#b3122b', re: /one[\s-]?piece/i },
    { k: 'yugioh',     icon: 'yugioh',     c: '#6b3fa0', re: /yu[\s-]?gi[\s-]?oh/i },
    { k: 'lorcana',    icon: 'lorcana',    c: '#1d6f83', re: /lorcana/i },
    { k: 'dragonball', icon: 'dragonball', c: '#d1690b', re: /dragon\s?ball/i },
    { k: 'digimon',    icon: 'digimon',    c: '#0b6fb8', re: /digimon/i },
    { k: 'starwars',   icon: 'starwars',   c: '#3f4650', re: /star\s?wars/i },
    { k: 'riftbound',  icon: 'riftbound',  c: '#9c1f8c', re: /riftbound/i },
    { k: 'gundam',     icon: 'gundam',     c: '#b31b34', re: /gundam/i },
    { k: 'fab',        icon: 'fab',        c: '#7c1d38', re: /flesh\s?(and|&)\s?blood/i },
    { k: 'weiss',      icon: 'weiss',      c: '#2f3440', re: /wei(ss|ß)\s?schwarz/i },
    { k: 'vanguard',   icon: 'singles',    c: '#7a1f3d', re: /vanguard|cardfight/i },
    { k: 'sports',     icon: 'sports',     c: '#146c43', re: /sport(s)?[\s-]?(cards|kaarten)/i },
    { k: 'singles',    icon: 'singles',    c: '#000f9f', re: /losse kaarten|singles/i },
    { k: 'board',      icon: 'board',      c: '#4b5563', re: /bordspel|board\s?game|gezelschap/i },
    { k: 'acc',        icon: 'acc',        c: '#4b5563', re: /accessoire|sleeve|kaarthoes|lichguard|toploader/i },
    { k: 'buy',        icon: 'buy',        c: '#146c43', re: /verkopen|inkoop|buylist/i },
    { k: 'sealed',     icon: 'sealed',     c: '#3f4650', re: /^tcg$|sealed/i }
  ];

  function svg(name, cls, game) {
    if (!ICONS[name]) return '';
    return '<svg class="' + (cls || 'lc-navicon') + '" viewBox="0 0 24 24" preserveAspectRatio="xMinYMid meet" aria-hidden="true" focusable="false"' +
      (game ? ' data-game="' + game + '"' : '') + '>' + ICONS[name] + '</svg>';
  }

  function matchGame(text) {
    if (!text) return null;
    for (var i = 0; i < GAMES.length; i++) { if (GAMES[i].re.test(text)) return GAMES[i]; }
    return null;
  }

  /* In het uitklapmenu (mega menu) zijn logo's en iconen een maat groter:
     vaste box van 64px breed, zodat de tekst van alle rijen op een lijn
     staat. Inline met priority 'important', want het thema zet zelf ook
     !important op de svg-breedte in het menu (17-08). */
  function lcMegaSize(a, el, h) {
    if (!el || !a.closest('.mega-menu__content')) return;
    if ((a.className || '').indexOf('mega-menu__link--level-3') === -1) return;
    el.style.setProperty('width', '64px', 'important');
    el.style.setProperty('height', h, 'important');
    el.style.setProperty('margin-right', '12px', 'important');
    el.style.setProperty('flex', 'none', 'important');
  }

  /* 1 - Iconen aan de menu-items hangen. Het thema tekent bij sommige items
     zelf een icoon, maar niet als <svg>: het gebruikt ::before met mask-image.
     Dat is niet met querySelector te vinden, dus dat icoon wordt in
     lichcards-design-cards.css met CSS verborgen. */
  function decorateNav(scope) {
    var links = (scope || document).querySelectorAll('#header-group a');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.lc-utility') || a.closest('.lc-mega')) return;

      var mine = a.querySelector('.lc-navicon');
      if (a.querySelector('svg:not(.lc-navicon), img:not(.lc-navlogo)')) {
        if (mine) mine.remove();
        a.classList.remove('lc-has-navicon');
        return;
      }
      if (mine) return;

      var label = (a.textContent || '').trim();
      if (!label || label.length > 40) return;
      var g = matchGame(label);
      if (!g) return;

      var logoUrl = LOGOS[g.k];
      if (g.k === 'acc') logoUrl = /lichguard/i.test(label) ? LOGOS.lichguard : null;
      if (logoUrl) {
        a.classList.add('lc-has-navicon');
        a.insertAdjacentHTML(
          'afterbegin',
          '<img class="lc-navicon lc-navlogo" src="' + logoUrl + '" alt="" loading="lazy"' +
            ' style="width:46px;height:20px;object-fit:contain;object-position:left center;flex:none;display:inline-block;">'
        );
        lcMegaSize(a, a.querySelector('img.lc-navlogo'), '30px');
        return;
      }

      a.classList.add('lc-has-navicon');
      a.insertAdjacentHTML('afterbegin', svg(g.icon, 'lc-navicon', g.k));
      var ic = a.querySelector('.lc-navicon');
      if (ic) ic.style.color = g.c;
      lcMegaSize(a, ic, '26px');
    });
  }

  /* Dubbele ingangen uit het hoofdmenu halen (staan al in de utility-balk) */
  function hideRedundantNavItems(scope) {
    if (!MENU_VERBERGEN.length) return;
    var links = (scope || document).querySelectorAll('#header-group a');
    Array.prototype.forEach.call(links, function (a) {
      if (a.closest('.lc-utility') || a.closest('.lc-mega')) return;
      var label = (a.textContent || '').trim().toLowerCase();
      if (MENU_VERBERGEN.indexOf(label) === -1) return;
      var item = a.closest('li') || a;
      if (item.dataset.lcHidden) return;
      item.dataset.lcHidden = '1';
      item.style.display = 'none';
    });
  }

  /* 4 - Utility-balk boven de header */
  function buildUtilityBar() {
    if (document.querySelector('.lc-utility')) return;
    var host = document.getElementById('header-group');
    if (!host || !host.parentNode) return;

    var left = [
      { t: 'Winkel in Enkhuizen', h: '/pages/contact', i: 'store' },
      { t: 'Gratis verzending vanaf 75 euro', h: '/policies/shipping-policy', i: 'truck' }
    ];
    var right = [
      { t: 'Verkoop je kaarten', h: '/pages/pokemon-kaarten-verkopen', i: 'buy' },
      { t: 'Spaarpunten', h: '/pages/spaarpunten', i: 'star' },
      { t: 'Contact', h: '/pages/contact', i: 'phone' }
    ];

    function list(items, cls) {
      return '<ul class="lc-utility__list ' + cls + '">' + items.map(function (it) {
        return '<li><a href="' + it.h + '">' + (it.i ? svg(it.i, 'lc-uicon') : '') + '<span>' + esc(it.t) + '</span></a></li>';
      }).join('') + '</ul>';
    }

    var bar = document.createElement('div');
    bar.className = 'lc-utility';
    bar.innerHTML = '<div class="lc-utility__in">' + list(left, 'lc-utility__list--left') + list(right, 'lc-utility__list--right') + '</div>';
    host.parentNode.insertBefore(bar, host);
  }

  /* 2 - Zichtbaar zoekveld. UITGEZET (AAN.zoekbalk = false). */
  function buildSearchBar() {
    if (!AAN.zoekbalk) return;
    if (document.querySelector('.lc-search')) return;
    var host = document.getElementById('header-group');
    if (!host || !host.parentNode) return;

    var wrap = document.createElement('div');
    wrap.className = 'lc-search';
    wrap.innerHTML =
      '<div class="lc-search__in">' +
        '<form class="lc-search__form" action="/search" method="get" role="search">' +
          '<input type="hidden" name="type" value="product">' +
          svg('zoek', 'lc-search__icon') +
          '<input class="lc-search__input" type="search" name="q" aria-label="Zoeken"' +
            ' placeholder="Zoek op kaart, set of product…" autocomplete="off">' +
          '<button class="lc-search__btn" type="submit">Zoeken</button>' +
        '</form>' +
      '</div>';

    if (host.nextSibling) host.parentNode.insertBefore(wrap, host.nextSibling);
    else host.parentNode.appendChild(wrap);
  }

  /* 27 - Collectietegels boven het raster. Bron: /search/suggest.json, want er
     bestaat geen lijst "welke sets horen bij dit spel". */
  function buildSetTiles() {
    if (!AAN.tegels) return;
    if (BODY.className.indexOf('template-collection') === -1) return;
    if (document.querySelector('.lc-sets')) return;

    var h1 = document.querySelector('#MainContent h1');
    var grid = document.querySelector('ul.product-grid');
    if (!h1 || !grid || !grid.parentNode) return;

    var titel = (h1.textContent || '').trim();
    if (!matchGame(titel)) return;

    var hier = location.pathname.replace(/\/$/, '');
    var url = '/search/suggest.json?q=' + encodeURIComponent(titel) +
              '&resources[type]=collection&resources[limit]=10';

    fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      var cols = ((((data || {}).resources || {}).results || {}).collections) || [];
      var gezien = {};
      var lijst = cols.filter(function (c) {
        if (!c.handle || !c.title) return false;
        var sleutel = c.title.toLowerCase().replace(/[^a-z0-9]/g, '');
        if ('/collections/' + c.handle === hier) return false;
        if (gezien[sleutel]) return false;
        gezien[sleutel] = 1;
        return true;
      }).slice(0, 6);

      if (lijst.length < 3) return;
      if (document.querySelector('.lc-sets')) return;

      var box = document.createElement('div');
      box.className = 'lc-sets';
      box.innerHTML = lijst.map(function (c) {
        return '<a class="lc-sets__tile" href="/collections/' + c.handle + '">' +
          '<span class="lc-sets__name">' + esc(c.title) + '</span></a>';
      }).join('');

      var kop = document.createElement('h2');
      kop.className = 'lc-sets__head';
      kop.textContent = 'Verfijn je keuze';

      var voor = document.querySelector('.lc-top3__head') || grid;
      voor.parentNode.insertBefore(kop, voor);
      kop.parentNode.insertBefore(box, kop.nextSibling);
    }).catch(function () {});
  }

  /* 16b - Lang knoplabel past niet op een smalle kaart */
  var SHORT_LABEL = 'In winkelwagen';

  function shortenAddLabels(scope) {
    var narrow = window.matchMedia('(max-width: 899px)').matches;
    var btns = (scope || document).querySelectorAll('.card .quick-add__submit, .card .add-to-cart-button');
    Array.prototype.forEach.call(btns, function (btn) {
      var span = btn.querySelector('span:not(.sold-out-message):not(.visually-hidden)') || btn;
      var full = btn.dataset.lcLabel;
      if (full === undefined) {
        full = (span.textContent || '').trim();
        if (!full || full.length < 4) return;
        btn.dataset.lcLabel = full;
        if (!btn.getAttribute('aria-label')) btn.setAttribute('aria-label', full);
      }
      var want = (narrow && full.length > 16) ? SHORT_LABEL : full;
      if ((span.textContent || '').trim() !== want) span.textContent = want;
    });
  }

  /* 19 - EUR achter de prijs weghalen */
  var MONEY = /(\s*)(EUR|USD|GBP)\b/g;

  function stripCurrencyCode(root) {
    var scope = root || document.body;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('EUR') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        if (p.closest('script,style,textarea,input,select,[data-lc-keep-currency]')) return NodeFilter.FILTER_REJECT;
        if (!p.closest('[class*="price"], .money, .lc-top3__price')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      node.nodeValue = node.nodeValue.replace(MONEY, '').replace(/\s{2,}/g, ' ');
    });
  }

  function readPrice(priceEl) {
    if (!priceEl) return null;
    function txt(el) { return el ? el.textContent.replace(MONEY, '').trim() : ''; }
    var wasEl = priceEl.querySelector('.price__sale s.price-item--regular, .price__sale del, s.price-item--regular, del');
    var nowEl = priceEl.querySelector('.price-item--sale') ||
                priceEl.querySelector('.price__regular .price-item--regular') ||
                priceEl.querySelector('.price-item--regular');
    return { was: txt(wasEl), now: txt(nowEl) };
  }

  function parseMoney(txt) {
    if (!txt) return null;
    var m = String(txt).replace(/\s/g, '').match(/([\d.]+,\d{2}|\d+[.,]\d{2}|\d+)/);
    if (!m) return null;
    var raw = m[1];
    if (raw.indexOf(',') > -1) raw = raw.replace(/\./g, '').replace(',', '.');
    var v = parseFloat(raw);
    return isNaN(v) ? null : v;
  }

  function imgSrc(img) {
    if (!img) return '';
    return img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
  }

  /* 20 + 21 - Badges */
  function upgradeBadges(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper, .product-card-wrapper');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.lcBadges) return;
      card.dataset.lcBadges = '1';

      var holder = card.querySelector('.card__badge');
      var priceEl = card.querySelector('.price');

      if (holder && priceEl) {
        var p = readPrice(priceEl);
        var was = parseMoney(p && p.was);
        var now = parseMoney(p && p.now);
        if (was && now && was > now) {
          var pct = Math.round((1 - now / was) * 100);
          if (pct > 0) {
            var sale = holder.querySelector('.sale-badge') || holder.querySelector('.badge');
            if (sale) {
              sale.textContent = '−' + pct + '%';
              sale.classList.add('lc-badge', 'lc-badge--sale');
            }
          }
        }
      }

      Array.prototype.forEach.call(card.querySelectorAll('.card__badge .badge, .card__badge span'), function (b) {
        var t = (b.textContent || '').trim().toLowerCase();
        b.classList.add('lc-badge');
        if (/uitverkocht|sold\s?out|niet op voorraad/.test(t)) b.classList.add('lc-badge--gone');
        else if (/nieuw|new/.test(t)) b.classList.add('lc-badge--new');
        else if (/pre[\s-]?order|verwacht/.test(t)) b.classList.add('lc-badge--pre');
        else if (/aanbieding|sale|korting|%|−/.test(t)) b.classList.add('lc-badge--sale');
      });
    });
  }

  /* 22 + 23 + 24 - Taalcode, conditie, rariteit */
  var LANGS = [
    { re: /japans|japanese/i,   code: 'JP', label: 'Japans' },
    { re: /engels|english/i,    code: 'EN', label: 'Engels' },
    { re: /duits|german/i,      code: 'DE', label: 'Duits' },
    { re: /frans|french/i,      code: 'FR', label: 'Frans' },
    { re: /italiaans|italian/i, code: 'IT', label: 'Italiaans' },
    { re: /spaans|spanish/i,    code: 'ES', label: 'Spaans' },
    { re: /koreaans|korean/i,   code: 'KR', label: 'Koreaans' },
    { re: /chinees|chinese/i,   code: 'CN', label: 'Chinees' }
  ];

  var RARITY = [
    { re: /secret\s?rare/i, k: 'secret',   t: 'Secret' },
    { re: /\bmythic\b/i,    k: 'mythic',   t: 'Mythic' },
    { re: /\bholo\b|\brare\b/i, k: 'rare', t: 'Rare' },
    { re: /\buncommon\b/i,  k: 'uncommon', t: 'Uncommon' },
    { re: /\bcommon\b/i,    k: 'common',   t: 'Common' }
  ];

  var CONDITION = [
    { re: /near\s?mint|\bnm\b/i, k: 'NM' },
    { re: /\bexcellent\b|\bex\b/i, k: 'EX' },
    { re: /\blightly\s?played\b|\bgood\b|\bgd\b|\blp\b/i, k: 'LP' },
    { re: /\bmoderately\s?played\b|\blight\s?played\b|\bmp\b/i, k: 'MP' },
    { re: /\bheavily\s?played\b|\bplayed\b|\bpl\b|\bhp\b/i, k: 'HP' },
    { re: /\bdamaged\b|\bpoor\b|\bpo\b|\bdmg\b/i, k: 'DMG' }
  ];

  function firstMatch(list, txt) {
    for (var i = 0; i < list.length; i++) { if (list[i].re.test(txt)) return list[i]; }
    return null;
  }

  function addChips(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper, .product-card-wrapper');
    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.lcChips) return;
      card.dataset.lcChips = '1';

      var h = card.querySelector('.card__heading');
      if (!h || !h.parentNode) return;
      var title = (h.textContent || '').trim();
      if (!title) return;

      var parts = [];
      var lang = firstMatch(LANGS, title);
      if (lang) parts.push('<span class="lc-chip lc-chip--lang" title="' + lang.label + '">' + lang.code + '</span>');
      var cond = firstMatch(CONDITION, title);
      if (cond) parts.push('<span class="lc-chip lc-chip--cond" data-c="' + cond.k + '">' + cond.k + '</span>');
      var rar = firstMatch(RARITY, title);
      if (rar) parts.push('<span class="lc-chip lc-chip--rar" data-r="' + rar.k + '">' + rar.t + '</span>');
      if (!parts.length) return;

      var box = document.createElement('div');
      box.className = 'lc-chips';
      box.innerHTML = parts.join('');
      h.parentNode.insertBefore(box, h.nextSibling);
    });
  }

  /* 13 - Broodkruimels */
  function buildBreadcrumb() {
    if (document.querySelector('.lc-breadcrumb')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    var m = BODY.className.match(/template-([a-z]+)/);
    var type = m ? m[1] : '';
    if (type !== 'collection' && type !== 'product') return;

    var trail = [{ t: 'Home', h: '/' }];
    var h1 = main.querySelector('h1');

    if (type === 'product') {
      var g = matchGame(document.title);
      var handles = { pokemon: 'pokemon-tcg', magic: 'mtg', onepiece: 'one-piece-booster-packs', yugioh: 'yu-gi-oh-tcg', lorcana: 'lorcana', dragonball: 'dragon-ball-super', digimon: 'digimon', starwars: 'star-wars-unlimited', riftbound: 'riftbound', board: 'bord-gezelschapsspellen', acc: 'tcg-accessoires' };
      var names = { pokemon: 'Pokémon', magic: 'Magic: The Gathering', onepiece: 'One Piece', yugioh: 'Yu-Gi-Oh!', lorcana: 'Disney Lorcana', dragonball: 'Dragon Ball Super', digimon: 'Digimon', starwars: 'Star Wars: Unlimited', riftbound: 'Riftbound', board: 'Bordspellen', acc: 'Accessoires' };
      if (g && handles[g.k]) trail.push({ t: names[g.k], h: '/collections/' + handles[g.k] });
    }
    if (h1) trail.push({ t: h1.textContent.trim(), h: null });
    if (trail.length < 2) return;

    var nav = document.createElement('nav');
    nav.className = 'lc-breadcrumb';
    nav.setAttribute('aria-label', 'Kruimelpad');
    nav.innerHTML = trail.map(function (s, i) {
      var last = i === trail.length - 1;
      var txt = esc(s.t.length > 60 ? s.t.slice(0, 57) + '…' : s.t);
      var el = (last || !s.h) ? '<span aria-current="page">' + txt + '</span>' : '<a href="' + s.h + '">' + txt + '</a>';
      return (i ? '<span class="lc-breadcrumb__sep">/</span>' : '') + el;
    }).join('');
    main.insertBefore(nav, main.firstChild);
  }

  /* 31 - Kleuraccent per spel */
  function applyGameAccent() {
    if (BODY.className.indexOf('template-collection') === -1) return;
    var h1 = document.querySelector('#MainContent h1');
    if (!h1) return;
    var g = matchGame(h1.textContent);
    if (!g) return;
    BODY.setAttribute('data-lc-game', g.k);
    BODY.style.setProperty('--lc-game', g.c);

    var prev = h1.previousElementSibling;
    if (!prev || !prev.classList.contains('lc-collection-flag')) {
      var flag = document.createElement('div');
      flag.className = 'lc-collection-flag';
      h1.parentNode.insertBefore(flag, h1);
    }
    if (!h1.querySelector('.lc-navicon')) {
      h1.insertAdjacentHTML('afterbegin', svg(g.icon, 'lc-navicon', g.k));
      var ic = h1.querySelector('.lc-navicon');
      if (ic) {
        ic.style.width = '0.75em'; ic.style.height = '0.75em'; ic.style.flex = 'none';
        ic.style.marginInlineEnd = '.3em'; ic.style.color = g.c;
        ic.style.verticalAlign = 'baseline'; ic.style.display = 'inline-block';
      }
    }
  }

  /* 28 - Top-3 met rangbadges */
  function buildTop3() {
    if (BODY.className.indexOf('template-collection') === -1) return;
    if (document.querySelector('.lc-top3')) return;

    var grid = document.querySelector('ul.product-grid');
    if (!grid || !grid.parentNode) return;
    var items = grid.querySelectorAll('.product-grid__item');
    if (items.length < 8) return;

    var sort = document.querySelector('[name="sort_by"]');
    var sv = sort ? sort.value : '';
    if (sv && !/best-selling|manual/.test(sv)) return;

    var rows = [];
    for (var i = 0; i < 3 && i < items.length; i++) {
      var it = items[i];
      var a = it.querySelector('a[href*="/products/"]');
      var src = imgSrc(it.querySelector('img'));
      var h = it.querySelector('.card__heading');
      var p = readPrice(it.querySelector('.price'));
      if (!a || !h) continue;
      var priceHtml = p ? (p.was ? '<s>' + esc(p.was) + '</s><em>' + esc(p.now) + '</em>' : esc(p.now)) : '';
      rows.push('<a class="lc-top3__row" href="' + a.getAttribute('href') + '">' +
        '<span class="lc-top3__rank">' + (i + 1) + '</span>' +
        (src ? '<img class="lc-top3__img" src="' + src + '" alt="' + esc(h.textContent.trim()) + '" loading="lazy">' : '<span></span>') +
        '<span class="lc-top3__title">' + esc(h.textContent.trim()) + '</span>' +
        '<span class="lc-top3__price">' + priceHtml + '</span></a>');
    }
    if (rows.length < 3) return;

    var head = document.createElement('h2');
    head.className = 'lc-top3__head';
    head.textContent = 'Meest gekocht';
    var box = document.createElement('div');
    box.className = 'lc-top3';
    box.innerHTML = rows.join('');
    grid.parentNode.insertBefore(box, grid);
    box.parentNode.insertBefore(head, box);
  }

  /* Bug uit de audit: sticky koopknop overlapte het label Aantal */
  function fixStickyOverlap() {
    if (BODY.className.indexOf('template-product') === -1) return;
    var qty = document.querySelector('.product-form__quantity, [class*="quantity"]');
    if (!qty) return;
    var label = qty.querySelector('label');
    if (label) {
      label.style.position = 'relative';
      label.style.zIndex = '2';
      label.style.background = '#fff';
      label.style.paddingInlineEnd = '6px';
    }
  }

  function runOnce() {
    try { buildUtilityBar(); } catch (e) {}
    try { buildSearchBar(); } catch (e) {}
    try { buildBreadcrumb(); } catch (e) {}
    try { applyGameAccent(); } catch (e) {}
    try { fixStickyOverlap(); } catch (e) {}
  }

  function runAlways(scope) {
    try { decorateNav(scope); } catch (e) {}
    try { hideRedundantNavItems(scope); } catch (e) {}
    try { stripCurrencyCode(scope); } catch (e) {}
    try { upgradeBadges(scope); } catch (e) {}
    try { addChips(scope); } catch (e) {}
    try { shortenAddLabels(scope); } catch (e) {}
  }

  function boot() {
    runOnce();
    runAlways(document);
    try { buildTop3(); } catch (e) {}
    try { buildSetTiles(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  var pending = null;
  var obs = new MutationObserver(function () {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      runAlways(document);
    });
  });
  obs.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', boot);

  var rt = null;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { try { shortenAddLabels(document); } catch (e) {} }, 150);
  });
})();
